// 拜访管理
const VisitRecord = () => import('@/pages/visit/visit-list.vue');

const arr = [
  // 商机管理
  {
    path: '/visit',
    name: 'visit',
    component: VisitRecord,
    meta: {
      auth: false,
    },
  },
];

export default arr;
